import { render } from "./OnboardingRequiredModal.vue?vue&type=template&id=d264c898&scoped=true"
import script from "./OnboardingRequiredModal.vue?vue&type=script&lang=js"
export * from "./OnboardingRequiredModal.vue?vue&type=script&lang=js"

import "./OnboardingRequiredModal.vue?vue&type=style&index=0&id=d264c898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d264c898"]])

export default __exports__